export const getMonoDashboardUrl = (stage) => {
    return `https://${stage}.d7b4tshwi0nrs.amplifyapp.com/`;
};
